import comp from "./GradeScaleDetailModal";
export default comp;
